import { CheckBox } from "components/common/CheckBox";
import { Heading, HeadingTag } from "components/common/Heading";
import { IndicativeCalculationBanner } from "components/common/IndicativeCalculationBanner";
import { VisibleSection } from "components/common/VisibleSection";
import { RepaymentOptionType } from "domain/indicativeRepaymentOptions";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import {
  IMORTANT_INFO_HEADING,
  CIRH_IMORTANT_INFO_TITLE,
  IMORTANT_INFO_TEXT2,
  CIRH_IMORTANT_INFO_TEXT3,
  IMORTANT_INFO_TEXT4,
  CIRH_EXTEND_TERM_CHKBOX_TEXT,
  CIRH_CHKBOX_TEXT,
  IMPORTANT_INFO_NOTE,
} from "./RequestRepaymentHoliday.const";
type CIRHImportantInformationProps = {
  selectedTreatments: SelectedTreatmentsDetails;
  checked: boolean;
  onChecked: (checked: boolean) => void;
};
export const CIRHImportantInformation = ({
  selectedTreatments,
  checked,
  onChecked,
}: CIRHImportantInformationProps) => {
  const isJustCIRH =
    selectedTreatments.repaymentOption?.optionType ===
    RepaymentOptionType.CIRHWithoutExtendTerm;
  return (
    <VisibleSection visible={!!selectedTreatments.repaymentOption}>
      <div className="imp-info">
        <Heading
          tag={HeadingTag.h2}
          size={2}
          className="zb-heading2"
          title={IMORTANT_INFO_HEADING}
        />
        <p>
          <strong>{CIRH_IMORTANT_INFO_TITLE}</strong>
        </p>
        <ul>
          <li>
            <span>
              Your loan will continue to <strong>accrue interest</strong> during
              the Capital & Interest repayment holiday that we will
              <strong> add to your loan</strong>
            </span>
          </li>
          <li>
            <span>{IMORTANT_INFO_TEXT2}</span>
          </li>
          <li>
            <span>{CIRH_IMORTANT_INFO_TEXT3}</span>
          </li>
          <li>
            <span>{IMORTANT_INFO_TEXT4}</span>
          </li>
        </ul>
        <p>{IMPORTANT_INFO_NOTE}</p>
        <IndicativeCalculationBanner />
        <CheckBox
          confirmType
          id="checkbox"
          checked={checked}
          label={isJustCIRH ? CIRH_CHKBOX_TEXT : CIRH_EXTEND_TERM_CHKBOX_TEXT}
          onChange={onChecked}
        />
      </div>
    </VisibleSection>
  );
};
